import { mediaBreakpointDown } from '@mote/ui/theme/core/breakpoints'
import styled from '@xstyled/styled-components'
import {
  CommonStyledScrubberWrapper,
  padding,
  scrubberMaxWidth
} from './Common.styles'

export const StyledPlayerButtonRowWrapper = styled.div({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  marginBottom: 24,
  width: '100%',
  maxWidth: scrubberMaxWidth
})

export const StyledTranscription = styled.div<{
  isLoopyMote: boolean
  isStickyButtonPresent: boolean
}>(
  {
    maxWidth: 748,
    height: 'calc(100% - 104px)',
    margin: '0 auto'
  },
  props =>
    props.isLoopyMote && {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      [mediaBreakpointDown('md')]: {
        maxWidth: '100%'
      }
    },
  props =>
    props.isStickyButtonPresent && {
      height: 'calc(100% - 120px)'
    }
)

export const StyledSticky = styled.div({
  maxWidth: 748,
  padding: '0 0.75rem',
  margin: '0 auto 0.25rem',
  '> a': {
    maxWidth: 450,
    'span.button-text': {
      overflow: 'hidden',
      whiteSpace: 'initial',
      display: '-webkit-box',
      '-webkit-line-clamp': '1',
      '-webkit-box-orient': 'vertical'
    }
  }
})

export const StyledScrubberWrapper = styled(CommonStyledScrubberWrapper)({
  marginBottom: 8,
  '>:last-child': {
    marginTop: 8
  }
})

export const ControlsWrapper = styled.div({
  position: 'absolute',
  right: padding,
  display: 'flex',
  gap: 8,
  alignItems: 'center'
})
